import { FONT_FAMILIES as C, DISALLOWED_COLOR_VALUES as h, BLOCK_CLASSES as m } from "../../constants.js";
import { defineAttrs as O } from "../../utils/typed-attrs.js";
import y from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const T = O({
  fontFamily: { default: "" },
  fontColor: { default: "" },
  backgroundColor: { default: "" },
  paddingTop: { default: "" },
  paddingBottom: { default: "" },
  paddingLeft: { default: "" },
  paddingRight: { default: "" },
  borderRadius: { default: "" },
  borderColor: { default: "" },
  borderWidth: { default: "" },
  borderStyle: { default: "" }
});
function b(a) {
  let s = "";
  return a.attrs.paddingTop && (s += `padding-top: ${a.attrs.paddingTop}; `), a.attrs.paddingBottom && (s += `padding-bottom: ${a.attrs.paddingBottom}; `), a.attrs.paddingLeft && (s += `padding-left: ${a.attrs.paddingLeft}; `), a.attrs.paddingRight && (s += `padding-right: ${a.attrs.paddingRight}; `), s;
}
function k(a) {
  var d;
  a.attrs = Object.assign({}, a.attrs, {
    fontFamily: { default: "" },
    fontColor: { default: "" },
    backgroundColor: { default: "" },
    paddingTop: { default: "" },
    paddingBottom: { default: "" },
    paddingLeft: { default: "" },
    paddingRight: { default: "" },
    borderRadius: { default: "" },
    borderColor: { default: "" },
    borderWidth: { default: "" },
    borderStyle: { default: "" }
  }), (d = a.parseDOM) == null || d.forEach(function(t) {
    const o = t.getAttrs;
    t.getAttrs = (r) => {
      const i = {};
      o && Object.assign(i, o(r));
      const {
        fontFamily: e,
        color: l,
        borderRadius: f,
        paddingTop: g,
        paddingBottom: u,
        paddingLeft: p,
        paddingRight: c
      } = (r == null ? void 0 : r.style) || {};
      if (e && C.includes(e) && Object.assign(i, { fontFamily: e }), l && !h.includes(l) && y(l).isValid()) {
        const n = y(l).toHexString();
        Object.assign(i, { fontColor: n });
      }
      if ((g || p || c || u) && Object.assign(i, { paddingTop: g, paddingLeft: p, paddingRight: c, paddingBottom: u }), f && Object.assign(i, { borderRadius: f }), r.classList.contains(m.button) || r.classList.contains("intercom-interblocks-button")) {
        const n = S(r.firstChild);
        Object.assign(i, n);
      }
      return i;
    };
  });
  const s = a.toDOM;
  return a.toDOM = (t) => {
    if (!s)
      throw new Error("must specify a toDOM method");
    const o = s(t);
    if (!Array.isArray(o) || o.length < 2)
      throw new Error("must specify at least two elements in output spec");
    o[1] === 0 && o.splice(1, 0, {});
    const r = o[1], i = o[2] ? o[2][1] : {};
    return r.style ?? (r.style = ""), i.style ?? (i.style = ""), t.attrs.fontFamily && (r.style += `font-family: ${t.attrs.fontFamily}; `), t.attrs.borderRadius && (i.style += `border-radius: ${t.attrs.borderRadius}; `), t.attrs.fontColor && (r.style += `color: ${t.attrs.fontColor}; `), t.attrs.backgroundColor && (t.attrs.responsive ? i.style += `background-color: ${t.attrs.backgroundColor}; ` : t.type.name !== "button" && !t.attrs.container && (r.style += `background-color: ${t.attrs.backgroundColor}; `)), t.attrs.borderColor && (r.style += `border-color: ${t.attrs.borderColor}; `), L(t) && (t.attrs.container ? r.style += b(t) : (i.style += b(t), t.attrs.responsive && (i.style += "border-collapse: separate; "))), r.style = r.style.trim(), i.style = i.style.trim(), r.style === "" && (r.style = null), i.style === "" && (i.style = null), o;
  }, a;
}
function S(a) {
  const {
    paddingTop: s,
    paddingRight: d,
    paddingLeft: t,
    paddingBottom: o,
    borderRadius: r,
    borderColor: i,
    borderWidth: e,
    borderStyle: l
  } = (a == null ? void 0 : a.style) || {};
  return {
    paddingTop: s,
    paddingRight: d,
    paddingLeft: t,
    paddingBottom: o,
    borderRadius: r,
    borderColor: i,
    borderWidth: e,
    borderStyle: l
  };
}
function L(a) {
  const { paddingTop: s, paddingRight: d, paddingLeft: t, paddingBottom: o } = a.attrs;
  return !!(s || d || t || o);
}
export {
  b as getPaddingStyles,
  k as stylable,
  T as stylableAttrs
};
